// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
  const theme = useTheme();
  const fill = theme.palette.text.primary;
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="OTM" width="100" />
     *
     */
    <>
      <svg width="190" height="35" viewBox="0 0 190 35" fill={fill} xmlns="http://www.w3.org/2000/svg">
        <g>
          <g>
            <path
              d="M57.8,7.2c-0.6-0.6-1.3-1-2-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-0.9,0-1.8,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2,1.4
			c-0.6,0.6-1,1.3-1.4,2.1c-0.3,0.8-0.5,1.6-0.5,2.5c0,0.9,0.2,1.8,0.5,2.5c0.3,0.8,0.8,1.5,1.4,2c0.6,0.6,1.3,1,2,1.4
			c0.8,0.3,1.6,0.5,2.5,0.5c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.8,2-1.4c0.6-0.6,1.1-1.3,1.4-2c0.3-0.8,0.5-1.6,0.5-2.5
			c0-0.9-0.2-1.7-0.5-2.5C58.8,8.5,58.4,7.8,57.8,7.2z M53.3,16.2c-0.6,0-1.2-0.1-1.7-0.3c-0.5-0.2-1-0.6-1.4-0.9
			c-0.4-0.4-0.7-0.9-0.9-1.4c-0.2-0.5-0.3-1.1-0.3-1.7c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.6-1,0.9-1.4C50.6,8.3,51,8,51.6,7.8
			c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.6,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7
			c0,0.6-0.1,1.2-0.3,1.7c-0.2,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.4,0.9C54.4,16.1,53.8,16.2,53.3,16.2z"
            />
            <path
              d="M71.3,7.3c-0.6-0.6-1.3-1.1-2-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-0.9,0-1.8,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2,1.4
			c-0.6,0.6-1,1.3-1.4,2c-0.3,0.8-0.5,1.6-0.5,2.5v6.5h2.1v-6.5c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.6-1,0.9-1.4
			c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.6,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4
			c0.2,0.5,0.3,1.1,0.3,1.7v6.5h2.1v-6.5c0-0.9-0.2-1.7-0.5-2.5C72.4,8.6,71.9,7.9,71.3,7.3z"
            />
            <path
              d="M88.8,11.8c0,0.6-0.1,1.2-0.3,1.7c-0.2,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.4,0.9c-0.5,0.2-1.1,0.3-1.7,0.3
			c-0.6,0-1.2-0.1-1.7-0.3c-0.5-0.2-1-0.6-1.4-0.9c-0.4-0.4-0.7-0.9-0.9-1.4C80.1,13,80,12.4,80,11.8v-2h3.3V7.8H80V3.6h-2.1v8.3
			c0,0.9,0.2,1.8,0.5,2.5c0.3,0.8,0.8,1.5,1.4,2c0.6,0.6,1.3,1,2,1.4c0.8,0.3,1.6,0.5,2.5,0.5c0.9,0,1.7-0.2,2.5-0.5
			c0.8-0.3,1.5-0.8,2-1.4c0.6-0.6,1.1-1.3,1.4-2c0.3-0.8,0.5-1.6,0.5-2.5v-0.4h-2.1V11.8z"
            />
            <path
              d="M102.6,7.3c-0.6-0.6-1.3-1.1-2-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-1.1,0-2.1,0.2-3,0.7c-0.5,0.3-1,0.6-1.4,1V3.2h-2.1v15.1
			h2.1v-6.5c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.6-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3
			c0.5,0.2,1,0.6,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7v6.5h2.1v-6.5c0-0.9-0.2-1.7-0.5-2.5
			C103.7,8.6,103.2,7.9,102.6,7.3z"
            />
            <path
              d="M143.8,7.2c-0.6-0.6-1.3-1-2.1-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-0.6,0-1.2,0.1-1.8,0.3c-0.6,0.2-1.1,0.4-1.6,0.8
			c-0.5,0.3-1,0.7-1.4,1.1c-0.2,0.2-0.4,0.5-0.6,0.8c-0.2-0.3-0.4-0.5-0.6-0.8c-0.4-0.4-0.8-0.8-1.3-1.1c-0.5-0.3-1.1-0.6-1.6-0.8
			c-0.6-0.2-1.2-0.3-1.8-0.3c-0.9,0-1.7,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2,1.4c-0.6,0.6-1.1,1.3-1.4,2.1c-0.3,0.8-0.5,1.6-0.5,2.5v6.5
			h2.1v-6.5c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.6-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3
			c0.5,0.2,1,0.6,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7v6.5h2.1v-6.5c0-0.6,0.1-1.2,0.3-1.7
			c0.2-0.5,0.6-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.6,1.4,0.9
			c0.4,0.4,0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7v6.5h2.1v-6.5c0-0.9-0.2-1.7-0.5-2.5C144.8,8.5,144.3,7.8,143.8,7.2z"
            />
            <path
              d="M157.4,7.2c-0.6-0.6-1.3-1-2-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-0.9,0-1.8,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2,1.4
			c-0.6,0.6-1,1.3-1.4,2.1c-0.3,0.8-0.5,1.6-0.5,2.5c0,0.9,0.2,1.8,0.5,2.5c0.3,0.8,0.8,1.5,1.4,2c0.6,0.6,1.3,1,2,1.4
			c0.8,0.3,1.6,0.5,2.5,0.5c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.5-0.8,2-1.4c0.6-0.6,1.1-1.3,1.4-2c0.3-0.8,0.5-1.6,0.5-2.5
			c0-0.9-0.2-1.7-0.5-2.5C158.4,8.5,158,7.8,157.4,7.2z M152.8,16.2c-0.6,0-1.2-0.1-1.7-0.3c-0.5-0.2-1-0.6-1.4-0.9
			c-0.4-0.4-0.7-0.9-0.9-1.4c-0.2-0.5-0.3-1.1-0.3-1.7c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.6-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-0.9
			c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,1,0.6,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7
			c0,0.6-0.1,1.2-0.3,1.7c-0.2,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.4,0.9C154,16.1,153.4,16.2,152.8,16.2z"
            />
            <polygon points="161.9,15.3 161.9,5.4 159.8,5.4 159.8,18.3 161.6,18.3 174.6,5.4 171.8,5.4 		" />
            <path
              d="M115.5,14.2c-0.3,0.5-0.7,0.9-1.2,1.3c-0.7,0.5-1.5,0.7-2.5,0.7c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.3-0.8
			c-0.4-0.3-0.7-0.7-1-1.2c-0.2-0.3-0.3-0.7-0.4-1h7.4h3.3v-1c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.8-1.5-1.4-2.1
			c-0.6-0.6-1.3-1-2.1-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-0.9,0-1.8,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2,1.4c-0.6,0.6-1,1.3-1.4,2.1
			c-0.3,0.8-0.5,1.6-0.5,2.5c0,0.9,0.2,1.8,0.5,2.5c0.3,0.8,0.8,1.5,1.4,2c0.6,0.6,1.3,1,2,1.4c0.8,0.3,1.6,0.5,2.5,0.5
			c0.7,0,1.4-0.1,2-0.4c0.6-0.2,1.2-0.5,1.8-0.9c0.5-0.4,1-0.9,1.4-1.4c0.3-0.4,0.6-0.9,0.8-1.4H115.5z M107.9,9.8
			c0.3-0.5,0.6-0.9,1-1.2c0.4-0.3,0.8-0.6,1.3-0.8c0.5-0.2,1-0.3,1.6-0.3c0.5,0,1.1,0.1,1.5,0.3c0.5,0.2,1,0.5,1.3,0.8
			c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.3,0.7,0.4,1h-8.6C107.6,10.4,107.8,10.1,107.9,9.8z"
            />
            <path
              d="M181.9,14.2c-0.3,0.5-0.7,0.9-1.2,1.3c-0.7,0.5-1.5,0.7-2.5,0.7c-0.6,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.3-0.8
			c-0.4-0.3-0.7-0.7-1-1.2c-0.2-0.3-0.3-0.7-0.4-1h7.4h3.3v-1c0-0.9-0.2-1.7-0.5-2.5c-0.3-0.8-0.8-1.5-1.4-2.1
			c-0.6-0.6-1.3-1-2.1-1.4c-0.8-0.3-1.6-0.5-2.5-0.5c-0.9,0-1.8,0.2-2.5,0.5c-0.8,0.3-1.5,0.8-2,1.4c-0.6,0.6-1,1.3-1.4,2.1
			c-0.3,0.8-0.5,1.6-0.5,2.5c0,0.9,0.2,1.8,0.5,2.5c0.3,0.8,0.8,1.5,1.4,2c0.6,0.6,1.3,1,2,1.4c0.8,0.3,1.6,0.5,2.5,0.5
			c0.7,0,1.4-0.1,2-0.4c0.6-0.2,1.2-0.5,1.8-0.9c0.5-0.4,1-0.9,1.4-1.4c0.3-0.4,0.6-0.9,0.8-1.4H181.9z M174.4,9.8
			c0.3-0.5,0.6-0.9,1-1.2c0.4-0.3,0.8-0.6,1.3-0.8c0.5-0.2,1-0.3,1.6-0.3c0.5,0,1.1,0.1,1.5,0.3c0.5,0.2,1,0.5,1.3,0.8
			c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.3,0.7,0.4,1H174C174,10.4,174.2,10.1,174.4,9.8z"
            />
          </g>
          <g>
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M47.6,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
			h3.8c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.4V27h2.3c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-2.3v2.9h3.4c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1H48c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M58.2,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
			c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2l4.3,6.1v-5.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3v7.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2
			l-4.3-6v5.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M70.3,24.3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3
			c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h4.3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
			s-0.2,0.1-0.3,0.1h-1.8v6.8c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-6.8
			H70.3z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M80.8,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1H85
			c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.4V27h2.3c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-2.3v2.9H85c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3
			c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.8c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M91.4,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h2
			c0.3,0,0.6,0.1,0.8,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.4,0.5,0.7c0.1,0.3,0.2,0.5,0.2,0.8c0,0.3,0,0.5-0.1,0.7
			c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.3,0.3-0.6,0.5c-0.2,0.1-0.5,0.2-0.7,0.3l1.9,3.1c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0,0.2
			c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.2l-2.1-3.5h-1.2v3.3
			c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z M92.1,24.3V27h1.7
			c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5
			c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1H92.1z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M101.7,24.3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3
			c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h4.3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
			s-0.2,0.1-0.3,0.1h-1.8v6.8c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-6.8
			H101.7z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M113.7,23.8c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
			c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2l3.1,7.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1
			c-0.2,0-0.3-0.1-0.4-0.2l-1-2.3h-3.5l-1,2.3c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3-0.1
			c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1L113.7,23.8z M114.1,24.9l-1.4,3.2h2.8L114.1,24.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M123.6,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
			c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v7.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1
			c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M130.6,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
			c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2l4.3,6.1v-5.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3v7.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2
			l-4.3-6v5.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M143.5,23.8c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.2-0.1,0.3-0.1
			c0.2,0,0.3,0.1,0.4,0.2l2.5,6.3l2.5-6.3c0.1-0.2,0.2-0.2,0.4-0.2c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.1,0.1,0.2L151,31v0.1
			c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.1-0.2l-0.7-5.7l-2.3,5.8
			c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2l-2.4-5.9l-0.8,5.8
			c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0
			L143.5,23.8z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M157,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h3.8
			c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.4V27h2.3c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-2.3v2.9h3.4c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.8c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9
			z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M167.6,23.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1
			c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2l4.3,6.1v-5.9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1
			c0.1,0.1,0.1,0.2,0.1,0.3v7.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2
			l-4.3-6v5.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V23.9z"
            />
            <path
              stroke="#000000"
              strokeWidth="0.25"
              d="M179.7,24.3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3
			c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h4.3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
			c-0.1,0.1-0.2,0.1-0.3,0.1h-1.8v6.8c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3
			v-6.8H179.7z"
            />
          </g>
          <g>
            <g>
              <path d="M11.5,15.7v9.4c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-9.4c0-0.9-0.7-1.6-1.6-1.6C12.2,14,11.5,14.8,11.5,15.7z" />
              <path d="M7,24.9c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V11.7c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6V24.9z" />
              <path d="M20.4,15.7v9.4c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-9.4c0-0.9-0.7-1.6-1.6-1.6C21.1,14,20.4,14.8,20.4,15.7z" />
              <path d="M24.8,11.7v13.3c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6V11.7c0-0.9-0.7-1.6-1.6-1.6S24.8,10.8,24.8,11.7z" />
              <path
                d="M28.8,4L28.8,4L28.8,4c-0.2-0.1-0.4-0.2-0.5-0.2c-0.3,0-0.5,0.2-0.5,0.6v1.8l0,0l0,1.4c0,0.3,0.1,0.8,0.6,1.3
				c0,0,0,0,0,0.1l0,0c1.9,2.4,2.9,5.4,2.9,8.4c0,7.6-6.2,13.8-13.8,13.8C10,31.2,3.8,25,3.8,17.4c0-3.1,1-6,2.9-8.4l0,0
				c0,0,0,0,0-0.1c0.5-0.5,0.5-1.1,0.6-1.4V6.2V5.5V4.4c0-0.3-0.2-0.6-0.5-0.6c-0.1,0-0.3,0-0.5,0.1l0,0l0,0C2.3,7.4,0,12.3,0,17.4
				C0,27,7.7,34.9,17.3,35v0h0.2c9.7,0,17.5-7.9,17.5-17.6C35.1,12.3,32.8,7.4,28.8,4z"
              />
              <path
                d="M8.9,6.6c0.1,0,0.3,0,0.4-0.1l0,0l0,0l0,0c1.9-1.4,4-2.3,6.3-2.6v21.2c0,1,0.7,1.7,1.6,1.9v0h0.2c1,0,1.9-0.8,1.9-1.9
				V3.8c2.3,0.3,4.4,1.2,6.3,2.6l0,0l0,0c0,0,0,0,0,0l0,0c0.2,0.1,0.3,0.2,0.4,0.2c0.3,0,0.5-0.2,0.5-0.6l0-2.7
				c0-0.5-0.2-0.9-0.6-1.1c-2.6-1.4-5.5-2.2-8.5-2.2h-0.2v0c-2.9,0-5.7,0.8-8.3,2.2C8.7,2.3,8.5,2.7,8.4,3.2V6
				C8.4,6.3,8.6,6.6,8.9,6.6z"
              />
            </g>
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    </>
  );
};

export default LogoMain;
